import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveCommittedTransactionVolumeMutationVariables = Types.Exact<{
  store_uuid: Types.Scalars['ID'];
}>;


export type RemoveCommittedTransactionVolumeMutation = { __typename?: 'Mutation', removeCommittedTransactionVolume: boolean };


export const RemoveCommittedTransactionVolumeDocument = gql`
    mutation removeCommittedTransactionVolume($store_uuid: ID!) {
  removeCommittedTransactionVolume(store_uuid: $store_uuid)
}
    `;
export type RemoveCommittedTransactionVolumeMutationFn = Apollo.MutationFunction<RemoveCommittedTransactionVolumeMutation, RemoveCommittedTransactionVolumeMutationVariables>;

/**
 * __useRemoveCommittedTransactionVolumeMutation__
 *
 * To run a mutation, you first call `useRemoveCommittedTransactionVolumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCommittedTransactionVolumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCommittedTransactionVolumeMutation, { data, loading, error }] = useRemoveCommittedTransactionVolumeMutation({
 *   variables: {
 *      store_uuid: // value for 'store_uuid'
 *   },
 * });
 */
export function useRemoveCommittedTransactionVolumeMutation(baseOptions?: Apollo.MutationHookOptions<RemoveCommittedTransactionVolumeMutation, RemoveCommittedTransactionVolumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveCommittedTransactionVolumeMutation, RemoveCommittedTransactionVolumeMutationVariables>(RemoveCommittedTransactionVolumeDocument, options);
      }
export type RemoveCommittedTransactionVolumeMutationHookResult = ReturnType<typeof useRemoveCommittedTransactionVolumeMutation>;
export type RemoveCommittedTransactionVolumeMutationResult = Apollo.MutationResult<RemoveCommittedTransactionVolumeMutation>;
export type RemoveCommittedTransactionVolumeMutationOptions = Apollo.BaseMutationOptions<RemoveCommittedTransactionVolumeMutation, RemoveCommittedTransactionVolumeMutationVariables>;